import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from '@/app/App';
import '@/index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the PWA service worker. Best-effort — failure must not block
// the main ERP SPA. Only enabled in production builds; in dev we want
// hot-reload + a clean network tab without SW caching layers in the way.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .catch((err) =>
        // eslint-disable-next-line no-console
        console.warn('[zafroi-pwa] service worker registration failed', err),
      );
  });
}
